import React from 'react';
import { Text } from '@/components';
import './ProgressStep.css';
const Vimeo = require('@u-wave/react-vimeo').default;

interface ProgressStepProps {
  stepIndex: number;
  title: string;
  description: string;
  videoSrc: string; // Optional video URL for future use
  videoRef?: React.RefObject<HTMLVideoElement> | null; // Optional video reference for future use
  progressPercentage?: number;
  isActive?: boolean;
  onClick?: () => void;
  onTimeUpdate: (currentTime: any) => void;
  onEnd: () => void;
  onReady: () => void;
}

export const ProgressStep: React.FC<ProgressStepProps> = ({
  stepIndex,
  title,
  description,
  videoSrc,
  videoRef,
  progressPercentage = 0,
  isActive = false,
  onClick,
  onTimeUpdate,
  onEnd,
  onReady
}) => {
  const clampedProgress = Math.max(0, Math.min(100, progressPercentage));

  return (
    <div
      className={`progress-step-container w-full lg:max-w-[272px] rounded-[14px] cursor-pointer ${isActive && 'active-step'}`}
      onClick={onClick}
    >
      <div className="progress-fill" style={{ width: `${clampedProgress}%` }}></div>
      <div className="flex flex-col items-start p-5">
        {videoRef && (
          <div className={`w-full p-0 tutorial-video-section z-[1] ${isActive ? 'h-full mb-6' : 'h-[0px]'}`}>
            <div className="w-full h-full tutorial-video-container">
              {/* vimeo video */}
              <Vimeo
                ref={videoRef}
                video={videoSrc}
                muted
                responsive
                playsInline
                play={true}
                autoplay={true}
                paused={!isActive}
                controls={false}
                className="video-display rounded-[10px] overflow-hidden"
                onTimeUpdate={onTimeUpdate}
                onEnd={onEnd}
                onReady={onReady}
              />
            </div>
          </div>
        )}

        <div className="flex flex-col items-start gap-2 w-full z-[1]">
          <div className="flex items-center gap-2 z-[1]">
            <div className={`p-[2px] rounded-[4px] w-[26px] h-[26px] flex ${isActive ? 'bg-[#68EFF5]' : 'bg-[#1E3A3C]'}`}>
              <Text.Description
                size="md"
                className={`m-auto !leading-[100%] ${isActive ? '!text-black' : '!text-[#68EFF5]'}`}
              >
                {stepIndex + 1}
              </Text.Description>
            </div>

            <Text.Description size="xs" className={`text-[16px] !leading-[20px] md:!leading-[20px] ${isActive ? '!text-white' : '!text-[#899FA0]'}`}>
              {title}
            </Text.Description>
          </div>

          <Text.Description size="md" className={`md:!text-[14px] md:!leading-[20px] ${isActive ? '!text-[#E3E3E3]' : '!text-[#5F7E7F]'}`}>
            {description}
          </Text.Description>
        </div>
      </div>
    </div>
  );
};
